export default function queryActionCreators(resourceName, actionTypes, api) {
    let actionCreators = {
        query: function (auth, params) {
            const controller = api.controller();

            return function (dispatch) {
                dispatch(actionCreators.request());

                return api
                    .query(auth, params, controller)
                    .then(
                        (response) =>
                            dispatch(
                                response.errors
                                    ? actionCreators.failure(response.errors)
                                    : actionCreators.success(response)
                            ),
                        (exception) =>
                            dispatch(actionCreators.failure(exception))
                    )
                    .then(
                        () => dispatch(actionCreators.complete()),
                        () => dispatch(actionCreators.complete())
                    );
            };
        },

        request: function () {
            let name = resourceName + '_QUERY_REQUEST';

            return {
                type: actionTypes[name],
            };
        },

        success: function (data) {
            let name = resourceName + '_QUERY_SUCCESS';

            return {
                data: data.data,
                payload: data,
                type: actionTypes[name],
            };
        },

        complete: function () {
            let name = resourceName + '_QUERY_COMPLETE';

            return {
                data: {},
                type: actionTypes[name],
            };
        },

        failure: function (errors) {
            let name = resourceName + '_QUERY_FAILURE';

            return {
                errors: errors,
                type: actionTypes[name],
            };
        },

        cancel: function (controller) {
            return function (dispatch) {
                api.cancel(controller);
                dispatch(actionCreators.cancelRequest());
            };
        },

        cancelRequest: function () {
            let name = resourceName + '_QUERY_CANCEL';
            return {
                type: actionTypes[name],
            };
        },
    };

    return {
        cancel: actionCreators.cancel,
        query: actionCreators.query,
    };
}
